export default __webpack_public_path__ + "static/media/montageanleitung.23f69261.pdf";